import { Box, CircularProgress, Grid } from '@mui/material';
import { useState } from 'react';
import toast from 'react-hot-toast';
import { useSelector } from 'react-redux';
import { useNavigate, useParams } from 'react-router-dom';
import CustomButtonContained from 'src/components/CustomButton/CustomButtonContained';
import { RootState } from 'src/redux-store/appStore';
import { httpRequest } from 'src/services/httpRequest';
import FormikSelect from 'src/ui-component/FormikFormLibrary/FormikSelect';
import FormikTextField from 'src/ui-component/FormikFormLibrary/FormikTextField';
import { sendNotification } from 'src/utils/sendNotification';

interface SelectedCaliperType {
  Trees: number;
  Caliper: string;
}

const ContentOnReplacementMethodChange = ({
  replacementMethodData,
  index,
  replacementFee,
  setReplacementFee,
  applicationData
}) => {
  const { applicationID, townshipId, permit } = useParams();
  const navigate = useNavigate();
  const socket = useSelector((state: RootState)=> state?.socket?.socket)
  const caliperOpt = ['2" - 2.5"', '3"', '3.5" - 4"'];
  const [caliperFieldCount, setCaliperFieldCount] = useState<number[]>([1]);
  const [replaceTrees, setReplaceTrees] = useState<number | string>();
  const [loading, setLoading] = useState<boolean>(false);
  const [selectedCaliperValues, setSelectedCaliperValues] = useState<
  SelectedCaliperType[]
  >([]);

  const handleNotifyVendor = async () => {
    setLoading(true);
    const caliperVal = [...selectedCaliperValues]?.map((val) => {
      return { ...val, Caliper: val?.Caliper?.replace(/"/g, '\\"') };
    });
    const vendorPayload = {
      ReplacementTreeCaliper: caliperVal,
      AdditionalEscrowFee: Number(replacementFee)
    };
    const townshipPayload = {
      ReplaceTrees: Number(replaceTrees)
    };
    const payload =
      replacementMethodData?.vendorToReplace === 'yes'
        ? vendorPayload
        : townshipPayload;
    const response = await httpRequest(
      'POST',
      `/tree_permit_application/${applicationID}/notify_vendor`,
      payload
    );

    if (response?.status === 'success') {
      sendNotification(socket, {
        UserID : applicationData?.UserID, 
        TownshipID : townshipId,
        Title:'Action Needed',
        ApplicationID: applicationID,
        PermitID: permit,
        Message : 
        `Need action on tree remove/replace application no. 
        ${applicationData?.ApplicationNumber}. 
        Check the application status for further details.`,

        ApplicationNumber : applicationData?.ApplicationNumber
      })
      setLoading(false);
      toast?.success(response?.message);
      setReplaceTrees(0);
      setReplacementFee(0);
      navigate(
        `/${townshipId}/Engineering Department/${permit}/application-list`
      );
    } else if (response?.type === 'NETWORK_ERROR') {
    } else {
      setLoading(false);
    }
  };

  const handleCaliperfield = (i) => {
    if (i > 0) {
      const tempCount = [...caliperFieldCount];
      tempCount.splice(i, 1);
      setCaliperFieldCount(tempCount);
      const caliperData = [...selectedCaliperValues];
      caliperData.splice(i, 1);
      setSelectedCaliperValues(caliperData);
    } else {
      setCaliperFieldCount([
        ...caliperFieldCount,
        caliperFieldCount[caliperFieldCount?.length - 1] + 1
      ]);
    }
  };

  const handleCaliperAndCountChange = (e, i) => {
    const { name, value } = e.target;
    const data = [...selectedCaliperValues];
    data.splice(i, 1, {
      ...data[i],
      [name]: value
    });
    setSelectedCaliperValues(data);
  };

  return (
    <Grid item xs={12} container alignItems="center" spacing={2}>
      {replacementMethodData?.vendorToReplace === 'yes' && index === 0 ? (
        <Grid item md={6} mb={2}>
          {caliperFieldCount?.map((val, i) => {
            return (
              <Box display={'flex'} key={i} mt={i > 0 ? 2 : ''}>
                <Grid item xs={10} mr={{xs:1, sm:2}} display={"flex"} flexDirection={{xs:"column", sm:"row"}}>
                <Box mb={{xs:1, sm:0}} mr={{xs:1, sm:2}}>
                  <FormikTextField
                    name={'Trees'}
                    label={'Replace Trees'}
                    type={'number'}
                    fieldValue={{
                      value:
                        selectedCaliperValues && selectedCaliperValues[i]?.Trees
                    }}
                    handleChange={(e) => {
                      handleCaliperAndCountChange(e, i);
                    }}
                  />
                </Box>
                <FormikSelect
                  initialValue={''}
                  label={'Select Replace Tree Caliper'}
                  fieldValue={{
                    value:
                      selectedCaliperValues && selectedCaliperValues[i]?.Caliper
                  }}
                  options={caliperOpt}
                  handleChange={(e) => {
                    handleCaliperAndCountChange(e, i);
                  }}
                  name={'Caliper'}
                />
                </Grid>
                <CustomButtonContained
                  title={i > 0 ? 'Delete' : 'Add'}
                  onClick={() => handleCaliperfield(i)}
                  sx={{ ml: {xs:0, sm:2} }}
                />
              </Box>
            );
          })}
          <Box display={'flex'} mt={2}>
            <Grid item md={5} mr={{xs:1, sm:3}}>
              <FormikTextField
                name={'replacementFee'}
                label={'Tree Replacement Fee'}
                type={'number'}
                fieldValue={{ value: replacementFee }}
                handleChange={(e) => {
                  setReplacementFee(e.target.value);
                }}
              />
            </Grid>
            <CustomButtonContained
              title={
                loading ? (
                  <CircularProgress size={24} sx={{ color: 'white' }} /> // Show spinner
                ) : (
                  'Notify Vendor'
                )
              }
              disabled={!replacementFee}
              onClick={handleNotifyVendor}
            />
          </Box>
        </Grid>
      ) : replacementMethodData?.townshipToReplace === 'yes' && index === 1 ? (
        <Box display={'flex'} mt={2} px={2} pr={{xs:0, sm:2}}>
          <Grid item md={6} mr={{xs:1, sm:3}}>
            <FormikTextField
              name={'replaceTrees'}
              label={'Replace Trees'}
              type={'number'}
              fieldValue={{
                value: replaceTrees ?? applicationData?.ReplaceTrees
              }}
              handleChange={(e) => {
                setReplaceTrees(e.target.value);
              }}
            />
          </Grid>
          <CustomButtonContained
            title={
              loading ? (
                <CircularProgress size={24} sx={{ color: 'white' }} /> // Show spinner
              ) : (
                'Notify Vendor'
              )
            }
            disabled={!replaceTrees}
            onClick={handleNotifyVendor}
          />
        </Box>
      ) : null}
    </Grid>
  );
};

export default ContentOnReplacementMethodChange;
